/*
 * Atolyewolf – yapışkan "Sepete ekle" çubuğu (tüm ürünler, mobil + masaüstü)
 *
 * Çubuk tüm ekranlarda sayfanın ALTINDA durur (CSS: sections/main-product.liquid). Mobilde ana "Sepete ekle" butonları
 * ekranda olmadığı her durumda (üstte ya da altta) görünür; tablet/masaüstünde yalnızca butonlar geçildikten sonra.
 * Alt bilgi (footer) görünürken gizlenir. Tema sınıfı is-visible'a dokunmaz, kendi sınıfını (aw-sticky-visible) kullanır.
 */

(() => {
  if (window.__awStickyAtc) return;
  window.__awStickyAtc = true;

  const init = (bar) => {
    if (bar.__awStickyInit) return;
    bar.__awStickyInit = true;

    const formId = bar.getAttribute('form');
    const form = document.forms[formId];
    const footer = document.querySelector('.shopify-section--footer');

    if (!form) return;

    // Ana butonlar: çubuğun dışındaki, aynı forma bağlı buy-buttons (yoksa formun kendisi)
    const target = [...document.querySelectorAll(`buy-buttons[form="${formId}"]`)].find((el) => !bar.contains(el)) || form;

    const mobile = window.matchMedia('(max-width: 699px)');
    let targetVisible = true;
    let targetAbove = false;
    let footerVisible = false;

    // Mobil: buton ekranda değilse (üstte ya da altta) göster. Tablet/masaüstü: yalnızca buton geçildikten sonra
    // (sayfa açılışında çubuk görünmez, başlığın/bilgilerin üstüne binmez).
    const update = () => {
      const show = !targetVisible && !footerVisible && (mobile.matches || targetAbove);
      bar.classList.toggle('aw-sticky-visible', show);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footer) {
          footerVisible = entry.isIntersecting;
        } else {
          targetVisible = entry.isIntersecting;
          targetAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      });

      update();
    });

    mobile.addEventListener('change', update);

    observer.observe(target);

    if (footer) {
      observer.observe(footer);
    }
  };

  const scan = () => document.querySelectorAll('product-sticky-bar').forEach(init);

  scan();

  // Varyant değişince tema çubuğu yeniden çizer (product-rerender) → yeni çubuğu da bağla
  document.addEventListener('variant:change', () => setTimeout(scan, 0));
  document.addEventListener('DOMContentLoaded', scan);
})();
